/**
 * Disclosure Agreement Page
 */

import { PolicyPage } from './PolicyPage';

const disclosureAgreementContent = `FULL FLOWRITHM DISCLOSURE AGREEMENT (FINAL DRAFT — 2026)
Owned by Lagori AI LLP
Last Updated: [Insert Date]

DISCLOSURE AGREEMENT
This Disclosure Agreement ("Agreement") outlines the risks, limitations, and user responsibilities associated with the use of FlowRithm, an AI-powered multi-broker trading and analytics platform operated by Lagori AI LLP.

By using FlowRithm, you acknowledge and accept all risks described below.

1. GENERAL RISK DISCLOSURE
Trading in financial markets (Equity, F&O, Commodity, Currency, MF) involves significant risk of loss and is not suitable for all investors.

Market risks include:
• Price volatility and rapid market movement
• Liquidity shortages
• High leverage causing amplified losses
• Margin calls
• Corporate actions, expiries, settlement issues
• Regulatory or macroeconomic events
• News-driven volatility

You may lose a substantial portion — or all — of your invested capital.

2. TECHNOLOGY & PLATFORM RISKS
FlowRithm is a technology platform built on cloud infrastructure, microservices, real-time APIs, and third-party systems. The Platform may experience:
• Server outages
• Cloud service downtime
• Delayed WebSocket/SSE updates
• Network failures
• High latency
• Bugs, errors, or misconfigurations

3. BROKER & API-LEVEL RISKS
FlowRithm connects to brokers via secure API integrations (OAuth). FlowRithm is not responsible for:
• Broker API failures or throttling
• Partial or failed order execution
• Incorrect positions/holdings data
• Delayed price updates
• Broker maintenance windows
• Rejected trades due to margin/rules

4. MARKET DATA & ANALYTICS RISKS
FlowRithm pulls market data from third-party vendors and broker-provided APIs. Due to dependencies:
• Prices may be delayed
• Charts/indicators may update late
• P&L may show incorrect or stale values
• Portfolio aggregation may temporarily mismatch broker data

5. ALGORITHMIC TRADING & BACKTESTING RISKS
Backtest results are theoretical and:
• Assume ideal conditions
• Do not account for slippage or impact
• Do not reflect real market microstructures
• Cannot predict future performance
• May overfit past data

6. ARTIFICIAL INTELLIGENCE (AI/ML) RISKS
FlowRithm uses AI/ML models for strategy enhancement, market explanations, and trading insights. AI limitations:
• Outputs may be inaccurate or misleading
• Models may fail under new market conditions
• AI suggestions are not a recommendation to trade
• AI cannot predict markets
• AI is probabilistic and cannot guarantee correctness

7. LIMITATION OF LIABILITY
To the fullest extent permitted by Indian law, FlowRithm and Lagori AI LLP shall not be liable for ANY loss, damage, or cost arising out of your use of the Platform.

Maximum aggregate liability shall never exceed the total subscription fee paid in the past 12 months.

8. CONTACT INFORMATION
For questions or concerns:
Lagori AI LLP
Email: contact@flowrithm.trade`;

export function DisclosureAgreementPage() {
  return <PolicyPage title="Disclosure Agreement" content={disclosureAgreementContent} />;
}

